const sectionSelector = '[data-savings-calculator]';
const rangeSelector = '[data-savings-range]';
const rangeValueAttributeName = 'data-savings-range-value';
const resultSelector = '[data-savings-result]';
const handlingSelector = '[data-savings-handling]';

const resultMin = 20;
const resultMax = 80;

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

function formatRangeValue(value) {
    return Number(value).toLocaleString('en-US');
}

function getRangeDelta(input) {
    const value = Number(input.value);
    const defaultValue = Number(input.dataset.defaultValue || input.defaultValue || input.min || 0);
    const min = Number(input.min || 0);
    const max = Number(input.max || 100);
    const range = max - min || 1;

    return (value - defaultValue) / range;
}

function calculateResult(section, rangeInputs) {
    const baseResult = Number(section.dataset.savingsBaseResult || 53);
    const travelSpendInput = rangeInputs.find((input) => input.dataset.savingsRange === 'travelSpend');
    const totalSpendInput = rangeInputs.find((input) => input.dataset.savingsRange === 'totalSpend');
    const activeHandlingInput = section.querySelector(handlingSelector + ':checked');
    const businessTripsInput = rangeInputs.find((input) => input.dataset.savingsRange === 'businessTrips');
    const travelSpendDelta = travelSpendInput ? getRangeDelta(travelSpendInput) : 0;
    const totalSpendDelta = totalSpendInput ? getRangeDelta(totalSpendInput) : 0;
    const handlingAdjustment = Number(activeHandlingInput?.dataset.savingsAdjustment || 0);
    const businessTripsDelta = businessTripsInput ? getRangeDelta(businessTripsInput) : 0;

    return clamp(Math.round(baseResult + travelSpendDelta * 18 + businessTripsDelta * 14 + totalSpendDelta * 8 + handlingAdjustment), resultMin, resultMax);
}

function updateRangeValue(section, input) {
    const valueOutput = section.querySelector(
        `[${rangeValueAttributeName}="${input.dataset.savingsRange}"]`
    );

    if (!valueOutput) {
        return;
    }

    valueOutput.textContent = formatRangeValue(input.value);
}

function updateResult(section, rangeInputs) {
    const result = section.querySelector(resultSelector);

    if (!result) {
        return;
    }

    result.textContent = calculateResult(section, rangeInputs);
}

export function initSavingsCalculatorSection() {
    const sections = document.querySelectorAll(sectionSelector);

    if (!sections.length) {
        return;
    }

    sections.forEach((section) => {
        const handlingInputs = Array.from(section.querySelectorAll(handlingSelector));
        const rangeInputs = Array.from(section.querySelectorAll(rangeSelector));

        if (!rangeInputs.length) {
            return;
        }

        rangeInputs.forEach((input) => {
            updateRangeValue(section, input);

            input.addEventListener('input', () => {
                updateRangeValue(section, input);
                updateResult(section, rangeInputs);
            });
            handlingInputs.forEach((input) => {
                input.addEventListener('change', () => {
                    updateResult(section, rangeInputs);
                });
            });
        });

        updateResult(section, rangeInputs);
    });
}
